module.exports = __webpack_public_path__ + "static/media/electric_car.baaa6c9e.png";